if (!window.nelkoFacetsReady) {
  window.nelkoFacetsReady = true

  document.addEventListener('click', handleNelkoFacetsClick)
  document.addEventListener('keydown', handleNelkoFacetsKeydown)
}

/**
 * @returns {Element | null}
 */
function getNelkoFacetsDrawer() {
  return document.querySelector('.nelko-facets-drawer')
}

function openNelkoFacetsDrawer() {
  var drawer = getNelkoFacetsDrawer()
  if (!drawer) return

  drawer.classList.add('is-open')
  drawer.setAttribute('aria-hidden', 'false')
  document.body.classList.add('overflow-hidden')
}

function closeNelkoFacetsDrawer() {
  var drawer = getNelkoFacetsDrawer()
  if (!drawer) return

  drawer.classList.remove('is-open')
  drawer.setAttribute('aria-hidden', 'true')
  document.body.classList.remove('overflow-hidden')
}

function handleNelkoFacetsClick(event) {
  var openTrigger = event.target.closest('[data-nelko-filters-open]')
  if (openTrigger) {
    event.preventDefault()
    openNelkoFacetsDrawer()
    return
  }

  if (event.target.closest('[data-nelko-filters-close]')) {
    event.preventDefault()
    closeNelkoFacetsDrawer()
  }
}

function handleNelkoFacetsKeydown(event) {
  if (event.key !== 'Escape') return

  var drawer = getNelkoFacetsDrawer()
  if (drawer && drawer.classList.contains('is-open')) {
    closeNelkoFacetsDrawer()
  }
}

window.openNelkoFacetsDrawer = openNelkoFacetsDrawer
window.closeNelkoFacetsDrawer = closeNelkoFacetsDrawer
